import { render, staticRenderFns } from "./UserGroupSelect.vue?vue&type=template&id=54b43b87&scoped=true&"
import script from "./UserGroupSelect.vue?vue&type=script&lang=js&"
export * from "./UserGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupSelect.vue?vue&type=style&index=0&id=54b43b87&scoped=true&lang=scss&"
import style1 from "./UserGroupSelect.vue?vue&type=style&index=1&id=54b43b87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b43b87",
  null
  
)

export default component.exports